module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chapter"
  }, [_vm._v("Praise for the Writing of Alyxandra Harvey")]), _vm._v(" "), _c('h3', {
    staticClass: "chapter"
  }, [_vm._v("The Drake Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“Vampires with bite and girls who bite back. A witty, exhilarating and fresh take on an old tale.” —Kelley Armstrong, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times–")]), _vm._v("bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“Fabulous and fast-paced! … The perfect escape read.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hearts at Stake")])]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“A smart mix of darkness and humor.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('h3', {
    staticClass: "chapter"
  }, [_vm._v("The Witches of London Trilogy")]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“A gorgeously gothic and gripping novel.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Guardian ")]), _vm._v("on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret Witch")])]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“Spell casting and paranormal creatures enliven this Regency fiction, which offers a cast of strong, witty women fighting for a higher good, all while finding romance, dressing up prettily, and going to lots of parties.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly ")]), _vm._v("on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret Witch")])]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“The relationships in this book are the highlight. … I love how [Emma, Gretchen and Penelope] are always looking out for each other and are ready to kick butt at anyone.” —YA Midnight Reads.comon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret Witch")])]), _vm._v(" "), _c('p', {
    staticClass: "topindent1"
  }, [_vm._v("“Will leave readers spellbound.” —DarkFaerieTales.com on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Whisper Witch\n")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a3d360c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Praise.vue
// module id = 57
// module chunks = 0